'use client';

import type { HeaderProps } from './header';
import dynamic from 'next/dynamic';
import StaticHeader from './header';

const DynamicHeader = dynamic(() => import('@/components/ui/header/reactive-header'), {
  // ssr: false,
  // Match the live header's `sticky` positioning so the loading fallback doesn't introduce
  // a hydration class mismatch (absolute vs fixed). The only consumer passes `sticky`.
  loading: () => <StaticHeader sticky />,
});

export default function Header(props: HeaderProps) {
  return <DynamicHeader {...props} />;
}
